export const catalogPresets = [
  {
    id: 'electrician',
    label: 'Électricien',
    items: [
      { id: 'elec-tableau', label: 'Installation tableau électrique', description: 'Installation / remplacement tableau électrique', unit: 'forfait', unitPrice: 850, vatRate: 10 },
      { id: 'elec-normes', label: 'Mise aux normes électrique', description: 'Mise en sécurité / conformité installation', unit: 'forfait', unitPrice: 450, vatRate: 10 },
      { id: 'elec-prises', label: 'Pose prises / interrupteurs', description: 'Fourniture + pose prises / interrupteurs', unit: 'unité', unitPrice: 55, vatRate: 10 },
      { id: 'elec-luminaires', label: 'Installation luminaires', description: 'Pose de luminaires', unit: 'unité', unitPrice: 65, vatRate: 10 },
      { id: 'elec-depannage', label: 'Dépannage électrique', description: 'Diagnostic + dépannage', unit: 'forfait', unitPrice: 120, vatRate: 10 },
      { id: 'elec-disjoncteur', label: 'Remplacement disjoncteur', description: 'Remplacement disjoncteur / protection', unit: 'unité', unitPrice: 95, vatRate: 10 },
      { id: 'elec-irve', label: 'Installation borne IRVE', description: 'Installation borne de recharge (IRVE)', unit: 'forfait', unitPrice: 1290, vatRate: 20 },
      { id: 'elec-main-h', label: 'Main d’œuvre horaire', description: 'Main d’œuvre', unit: 'h', unitPrice: 55, vatRate: 10 },
      { id: 'elec-depl', label: 'Déplacement', description: 'Frais de déplacement', unit: 'forfait', unitPrice: 35, vatRate: 10 },
      { id: 'elec-acompte', label: 'Acompte chantier', description: 'Acompte avant démarrage', unit: 'forfait', unitPrice: 500, vatRate: 10 }
    ]
  },
  {
    id: 'plumber',
    label: 'Plombier',
    items: [
      { id: 'plb-chauffe-eau', label: 'Installation chauffe-eau', description: 'Installation / remplacement chauffe-eau', unit: 'forfait', unitPrice: 690, vatRate: 10 },
      { id: 'plb-chaudiere', label: 'Remplacement chaudière', description: 'Remplacement chaudière', unit: 'forfait', unitPrice: 1890, vatRate: 10 },
      { id: 'plb-fuite', label: 'Dépannage fuite', description: 'Recherche + réparation fuite', unit: 'forfait', unitPrice: 140, vatRate: 10 },
      { id: 'plb-wc', label: 'Pose WC / lavabo', description: 'Pose WC / lavabo', unit: 'forfait', unitPrice: 240, vatRate: 10 },
      { id: 'plb-douche', label: 'Installation douche', description: 'Installation douche', unit: 'forfait', unitPrice: 590, vatRate: 10 },
      { id: 'plb-recherche-fuite', label: 'Recherche fuite', description: 'Recherche fuite (hors réparation)', unit: 'forfait', unitPrice: 110, vatRate: 10 },
      { id: 'plb-depl', label: 'Déplacement', description: 'Frais de déplacement', unit: 'forfait', unitPrice: 35, vatRate: 10 },
      { id: 'plb-urgence', label: 'Forfait urgence', description: 'Forfait urgence (en plus)', unit: 'forfait', unitPrice: 60, vatRate: 20 },
      { id: 'plb-acompte', label: 'Acompte chantier', description: 'Acompte avant démarrage', unit: 'forfait', unitPrice: 500, vatRate: 10 }
    ]
  },
  {
    id: 'btp',
    label: 'BTP / chantier',
    items: [
      { id: 'btp-sdb', label: 'Rénovation salle de bain complète', description: 'Rénovation salle de bain (forfait)', unit: 'forfait', unitPrice: 4900, vatRate: 10 },
      { id: 'btp-cuisine', label: 'Rénovation cuisine', description: 'Rénovation cuisine (forfait)', unit: 'forfait', unitPrice: 4200, vatRate: 10 },
      { id: 'btp-carrelage', label: 'Pose carrelage', description: 'Pose carrelage', unit: 'm²', unitPrice: 55, vatRate: 10 },
      { id: 'btp-ravalement', label: 'Ravalement façade', description: 'Ravalement façade', unit: 'm²', unitPrice: 38, vatRate: 10 },
      { id: 'btp-isolation', label: 'Isolation murs', description: 'Isolation murs', unit: 'm²', unitPrice: 42, vatRate: 10 },
      { id: 'btp-placo', label: 'Cloison placo', description: 'Cloison placo', unit: 'm²', unitPrice: 48, vatRate: 10 },
      { id: 'btp-evac', label: 'Évacuation gravats', description: 'Évacuation et mise en déchetterie', unit: 'forfait', unitPrice: 160, vatRate: 20 },
      { id: 'btp-nettoyage', label: 'Nettoyage fin de chantier', description: 'Nettoyage de fin de chantier', unit: 'forfait', unitPrice: 120, vatRate: 20 },
      { id: 'btp-depl', label: 'Déplacement', description: 'Déplacement chantier', unit: 'forfait', unitPrice: 45, vatRate: 20 },
      { id: 'btp-acompte', label: 'Acompte chantier', description: 'Acompte avant démarrage', unit: 'forfait', unitPrice: 800, vatRate: 10 }
    ]
  },
  {
    id: 'commerce',
    label: 'Commerce / vente',
    items: [
      { id: 'com-produit', label: 'Vente produit', description: 'Vente produit', unit: 'unité', unitPrice: 29, vatRate: 20 },
      { id: 'com-lot', label: 'Vente lot', description: 'Vente lot / pack', unit: 'forfait', unitPrice: 99, vatRate: 20 },
      { id: 'com-remise', label: 'Remise commerciale', description: 'Remise commerciale (%)', unit: 'forfait', unitPrice: 0, vatRate: 0 },
      { id: 'com-livraison', label: 'Frais livraison', description: 'Frais de livraison', unit: 'forfait', unitPrice: 8, vatRate: 10 },
      { id: 'com-cadeau', label: 'Carte cadeau', description: 'Carte cadeau', unit: 'unité', unitPrice: 50, vatRate: 20 },
      { id: 'com-bon', label: 'Bon d’achat', description: 'Bon d’achat', unit: 'unité', unitPrice: 50, vatRate: 20 }
    ]
  },
  {
    id: 'liberal',
    label: 'Profession libérale',
    items: [
      { id: 'lib-cabinet', label: 'Consultation cabinet', description: 'Consultation au cabinet', unit: 'unité', unitPrice: 85, vatRate: 20 },
      { id: 'lib-domicile', label: 'Consultation domicile', description: 'Consultation à domicile', unit: 'unité', unitPrice: 110, vatRate: 20 },
      { id: 'lib-tele', label: 'Téléconsultation', description: 'Téléconsultation', unit: 'unité', unitPrice: 70, vatRate: 20 },
      { id: 'lib-suivi', label: 'Forfait suivi', description: 'Forfait suivi', unit: 'mois', unitPrice: 120, vatRate: 20 },
      { id: 'lib-expertise', label: 'Expertise', description: 'Expertise', unit: 'forfait', unitPrice: 350, vatRate: 20 },
      { id: 'lib-rapport', label: 'Rapport', description: 'Rapport', unit: 'unité', unitPrice: 90, vatRate: 20 }
    ]
  },
  {
    id: 'freelance',
    label: 'Freelance',
    items: [
      { id: 'free-site', label: 'Création site web', description: 'Création / refonte site web', unit: 'forfait', unitPrice: 1800, vatRate: 20 },
      { id: 'free-maint', label: 'Maintenance mensuelle', description: 'Maintenance mensuelle', unit: 'mois', unitPrice: 290, vatRate: 20 },
      { id: 'free-audit', label: 'Audit stratégique', description: 'Audit / recommandations', unit: 'forfait', unitPrice: 450, vatRate: 20 },
      { id: 'free-consult', label: 'Consulting visio', description: 'Consulting en visio', unit: 'h', unitPrice: 90, vatRate: 20 },
      { id: 'free-cm', label: 'Community management mensuel', description: 'Community management mensuel', unit: 'mois', unitPrice: 450, vatRate: 20 },
      { id: 'free-logo', label: 'Design logo', description: 'Création logo', unit: 'forfait', unitPrice: 350, vatRate: 20 },
      { id: 'free-branding', label: 'Pack branding', description: 'Pack branding', unit: 'forfait', unitPrice: 900, vatRate: 20 },
      { id: 'free-retainer', label: 'Retainer mensuel', description: 'Accompagnement mensuel', unit: 'mois', unitPrice: 590, vatRate: 20 }
    ]
  },
  {
    id: 'beauty',
    label: 'Salon beauté / manucure',
    items: [
      { id: 'beauty-pose-gel', label: 'Pose complète gel', description: 'Pose complète gel', unit: 'unité', unitPrice: 60, vatRate: 20 },
      { id: 'beauty-remplissage', label: 'Remplissage', description: 'Remplissage', unit: 'unité', unitPrice: 42, vatRate: 20 },
      { id: 'beauty-nailart', label: 'Nail art', description: 'Nail art', unit: 'unité', unitPrice: 15, vatRate: 20 },
      { id: 'beauty-depose', label: 'Dépose', description: 'Dépose', unit: 'unité', unitPrice: 18, vatRate: 20 },
      { id: 'beauty-mani', label: 'Manucure simple', description: 'Manucure simple', unit: 'unité', unitPrice: 25, vatRate: 20 },
      { id: 'beauty-pieds', label: 'Beauté des pieds', description: 'Beauté des pieds', unit: 'unité', unitPrice: 35, vatRate: 20 },
      { id: 'beauty-mariage', label: 'Forfait mariage', description: 'Forfait mariage', unit: 'forfait', unitPrice: 120, vatRate: 20 },
      { id: 'beauty-cadeau', label: 'Carte cadeau', description: 'Carte cadeau', unit: 'unité', unitPrice: 50, vatRate: 20 }
    ]
  },
  {
    id: 'coach',
    label: 'Coachs / thérapeutes',
    items: [
      { id: 'coach-seance', label: 'Séance individuelle', description: 'Séance individuelle', unit: 'unité', unitPrice: 70, vatRate: 20 },
      { id: 'coach-visio', label: 'Séance visio', description: 'Séance visio', unit: 'unité', unitPrice: 60, vatRate: 20 },
      { id: 'coach-pack10', label: 'Forfait 10 séances', description: 'Forfait 10 séances', unit: 'forfait', unitPrice: 600, vatRate: 20 },
      { id: 'coach-bilan', label: 'Bilan initial', description: 'Bilan initial', unit: 'unité', unitPrice: 90, vatRate: 20 },
      { id: 'coach-prog', label: 'Programme personnalisé', description: 'Programme personnalisé', unit: 'forfait', unitPrice: 250, vatRate: 20 },
      { id: 'coach-abo', label: 'Abonnement mensuel', description: 'Abonnement mensuel', unit: 'mois', unitPrice: 150, vatRate: 20 }
    ]
  },
  {
    id: 'services',
    label: 'Services généraux',
    items: [
      { id: 'srv-maint', label: 'Maintenance', description: 'Maintenance générale', unit: 'h', unitPrice: 40, vatRate: 20 },
      { id: 'srv-clean', label: 'Nettoyage', description: 'Prestation de nettoyage', unit: 'h', unitPrice: 25, vatRate: 20 },
      { id: 'srv-vitrerie', label: 'Vitrerie', description: 'Nettoyage vitres', unit: 'forfait', unitPrice: 45, vatRate: 20 },
      { id: 'srv-entretien', label: 'Entretien régulier', description: 'Entretien régulier', unit: 'mois', unitPrice: 180, vatRate: 20 },
      { id: 'srv-consum', label: 'Consommables', description: 'Consommables', unit: 'forfait', unitPrice: 20, vatRate: 20 }
    ]
  }
];

export const suggestCatalogSector = (input = '') => {
  const text = String(input)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s'-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const has = (value) => text.includes(value);
  const hasAny = (values) => values.some((value) => has(value));

  if (hasAny(['manucure', 'ongle', 'onglerie', 'beaute', 'esthetique'])) {
    return 'beauty';
  }
  if (hasAny(['electricien', 'elect', 'tableau', 'irve'])) {
    return 'electrician';
  }
  if (hasAny(['plombier', 'plomberie', 'chaudiere', 'chauffe-eau', 'chauffe eau', 'fuite'])) {
    return 'plumber';
  }
  if (hasAny(['btp', 'chantier', 'maconnerie', 'gros oeuvre', 'second oeuvre', 'renovation'])) {
    return 'btp';
  }
  if (hasAny(['commerce', 'boutique', 'vente', 'produit', 'stock'])) {
    return 'commerce';
  }
  if (hasAny(['liberal', 'honoraire', 'consultation', 'cabinet'])) {
    return 'liberal';
  }

  // Freelance / web / marketing / design
  // Important: "site" seul est ambigu (chantier). On vise les signaux forts: "site vitrine", "web", "wordpress", etc.
  const hasWebsiteIntent =
    (has('site') && hasAny(['web', 'internet', 'vitrine'])) ||
    hasAny([
      'site web',
      'site vitrine',
      'vitrine',
      'wordpress',
      'shopify',
      'woocommerce',
      'ecommerce',
      'e-commerce',
      'landing',
      'seo',
      'referencement',
      'google',
      'webdesign',
      'ui',
      'ux',
      'react',
      'application',
      'appli',
      'developpement',
      'dev',
      'creation de site',
      'refonte'
    ]);

  const hasFreelanceCommercial = hasAny(['freelance', 'mission', 'retainer', 'community management', 'branding', 'logo']);
  const hasWebMaintenance = has('maintenance') && hasAny(['site', 'web', 'wordpress', 'hebergement', 'hosting']);

  if (hasWebsiteIntent || hasFreelanceCommercial || hasWebMaintenance) {
    return 'freelance';
  }
  if (hasAny(['coach', 'therapeute', 'sophro', 'psy', 'bien-etre', 'bien etre', 'bien etre'])) {
    return 'coach';
  }


  return 'services';
};
